var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg30(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47266 14.9746H9.87891V18.4352H8.47266V14.9746Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 14.9805H12.7031V18.441H11.2969V14.9805Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64648 14.9697H7.05273V18.4303H5.64648V14.9697Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 14.9834H15.5273V18.444H14.1211V14.9834Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9473 14.9854H18.3535V18.4459H16.9473V14.9854Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 7.95507V9.3623H20.7857C20.8637 9.14227 20.9062 8.9056 20.9062 8.65918C20.9062 8.11941 20.7025 7.62638 20.3678 7.25293C20.7025 6.87948 20.9062 6.38645 20.9062 5.84668C20.9062 4.68357 19.96 3.7373 18.7969 3.7373H6.60938C4.67086 3.7373 3.09375 5.31441 3.09375 7.25293C3.09375 8.04371 3.3562 8.77435 3.79856 9.3623H1.40625V7.95507H0V13.5811H1.5233L2.51958 19.0231C2.75714 20.3207 3.88697 21.2624 5.20613 21.2624H18.7939C20.1131 21.2624 21.2429 20.3206 21.4805 19.0231L22.4767 13.5811H24V7.95507H22.5938ZM22.5938 12.1748H1.40625V10.7686H22.5938V12.1748ZM4.5 7.25293C4.5 6.08982 5.44627 5.14355 6.60938 5.14355H18.7969C19.1846 5.14355 19.5 5.45898 19.5 5.84668C19.5 6.23438 19.1846 6.5498 18.7969 6.5498H6.74391V7.95605H18.7969C19.1846 7.95605 19.5 8.27148 19.5 8.65918C19.5 9.04688 19.1846 9.3623 18.7969 9.3623H6.60938C5.44627 9.3623 4.5 8.41609 4.5 7.25293ZM20.0971 18.7699C19.9819 19.3994 19.4338 19.8562 18.7939 19.8562H5.20613C4.56619 19.8562 4.01808 19.3994 3.90286 18.7699L2.95294 13.5811H21.0471L20.0971 18.7699Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/30.56a4a4d0bda74a6450abac25017328ce.svg";
export { ForwardRef as ReactComponent };